import axios from "axios";
import {BACKEND} from "../config/backend";
import { AXIOS_TIMEOUTS } from "../axios-config/apiTimeouts";

const TIMEOUT = AXIOS_TIMEOUTS.standard

export const createAuthHeader = token => token ? ({headers: {
        'Authorization': `Bearer ${token}`
    }, timeout: TIMEOUT}) : ({timeout: TIMEOUT})

export const createMultipartFormHeader = token => ({headers: {
        'content-type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
    }, timeout: 30000})

export const createAuthHeaderForImages = token => token ? ({headers: {
        'Authorization': `Bearer ${token}`
    }, timeout: AXIOS_TIMEOUTS.image}) : ({timeout: AXIOS_TIMEOUTS.image})

export const addAuthHeader = (token, header) => token ? ({headers: {...header,
        'Authorization': `Bearer ${token}`
    }, timeout: TIMEOUT}) : ({timeout: TIMEOUT})

export const getArtistRefreshTokenEndpoint = refreshToken => `${BACKEND}/api/v1/artists/loginArtist/refresh?token=${encodeURIComponent(refreshToken)}`

export const createArtistRefreshRequestConfig = token => ({
    ...createAuthHeader(token),
    withCredentials: true,
})

export const getArtistRefreshToken = ({refreshToken, token}) => {
    return axios.get(getArtistRefreshTokenEndpoint(refreshToken), createArtistRefreshRequestConfig(token))
}

export const getStudioRefreshTokenEndpoint = refreshToken => `${BACKEND}/api/v1/users/loginStudio/refresh?token=${encodeURIComponent(refreshToken)}`

export const getStudioRefreshToken = ({refreshToken}) => {
    return axios.get(getStudioRefreshTokenEndpoint(refreshToken))
}

export const getCountryMap = () => {
    return axios.get(`${BACKEND}/api/v1/countries`)
}

export const getStudio = ({token}) => {
    return axios.get(`${BACKEND}/api/v1/studio`, {
        ...createAuthHeader(token)
    })
}

export const updateStudio = ({token, studio}) => {
    return axios.put(`${BACKEND}/api/v1/studio`, studio, {
        ...createAuthHeader(token)
    })
}

export const getTermintypen = ({token}) => {
    return axios.get(`${BACKEND}/api/v1/studio/termintypen`, {
        ...createAuthHeader(token)
    })
}

export const loginStudio = ({studio, password}) => {
    return axios.post(`${BACKEND}/api/v1/users/loginStudio`, {studio, password})
}

export const loginArtist = ({token, kuerzel, password}) => {
    return axios.post(`${BACKEND}/api/v1/artists/loginArtist`, {kuerzel, password}, {
        ...createAuthHeader(token),
        withCredentials: true,
    })
}

export const initiateStudioLoginReset = ({studio, locale}) => {
    return axios.post(`${BACKEND}/api/v1/users/studio/password/reset`, {studio, locale})
}




